exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "#kj-app[data-v-8399f25c]{font-size:14px;color:#333;overflow-scrolling:touch;background-color:#fff;font-family:PingFang SC,Lantinghei,Microsoft YaHei,Helvetica Neue,Helvetica,Lucida Grande,STHeiTi,Arial,sans-serif}", "", {"version":3,"sources":["/Users/Min/Work/Code/ThirdApps/kanjia/front/src/App.vue"],"names":[],"mappings":"AACA,yBACE,eAAgB,AAChB,WAAY,AACZ,yBAA0B,AAC1B,sBAAuB,AACvB,kHAAoI,CACrI","file":"App.vue","sourcesContent":["\n#kj-app[data-v-8399f25c] {\n  font-size: 14px;\n  color: #333;\n  overflow-scrolling: touch;\n  background-color: #fff;\n  font-family: \"PingFang SC\", Lantinghei, \"Microsoft YaHei\", \"Helvetica Neue\", Helvetica, \"Lucida Grande\", STHeiTi, Arial, sans-serif;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8399f25c","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 240
// module chunks = 0